var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDolar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_192_1896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0833 113.75V27.0833C27.0833 24.2102 28.2247 21.4547 30.2563 19.423C32.288 17.3914 35.0435 16.25 37.9166 16.25H92.0833C94.9565 16.25 97.712 17.3914 99.7436 19.423C101.775 21.4547 102.917 24.2102 102.917 27.0833V113.75L86.6666 102.917L75.8333 113.75L65 102.917L54.1666 113.75L43.3333 102.917L27.0833 113.75Z",
    stroke: "white",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1667 43.3333C79.1854 41.6312 77.7598 40.228 76.0423 39.2738C74.3249 38.3197 72.3803 37.8506 70.4167 37.9167H59.5833C56.7102 37.9167 53.9547 39.058 51.923 41.0897C49.8914 43.1213 48.75 45.8768 48.75 48.75C48.75 51.6232 49.8914 54.3787 51.923 56.4103C53.9547 58.442 56.7102 59.5833 59.5833 59.5833H70.4167C73.2898 59.5833 76.0453 60.7247 78.077 62.7563C80.1086 64.788 81.25 67.5435 81.25 70.4167C81.25 73.2898 80.1086 76.0453 78.077 78.077C76.0453 80.1086 73.2898 81.25 70.4167 81.25H59.5833C57.6197 81.3161 55.6751 80.847 53.9577 79.8928C52.2402 78.9387 50.8146 77.5354 49.8333 75.8333",
    stroke: "white",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 32.5V86.6667",
    stroke: "white",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_192_1896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 130,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDolar);
export default __webpack_public_path__ + "static/media/dolar.c8933f16c45071f821de10dccd36384a.svg";
export { ForwardRef as ReactComponent };